/**
 * author: @varun
 */
var appCtrlModule = angular.module('AppCtrl');
appCtrlModule.controller('CampaignContactListCtrl', ['$scope', 'modalService', 'actionModalService',
	function ($scope, modalService, actionModalService) {
		$scope.count = 0;

		//This object fills the information related to the selection on the grid. Which will be used on filling the information on the camapaing modal box.
		$scope._resultObjects = {};

		$scope.$on('campaignSelectionCount', function (event, resultObject) {
			$scope._resultObjects = resultObject;
			$scope.count = resultObject.selectedCount;
		});

		$scope.scheduleCampaign = function () {
			// actionModalService.getRequisition({
			// page: 0
			// }, function( results ){
			// modalService.selectRequisition( results );
			// });
			var modalObject = {
				'ids': $scope._resultObjects.selectedEIds,
				'selectedObjects': $scope._resultObjects.selectedObjects
			};
			modalService.getScheduleCampaign(modalObject);
		};

		$scope.replaceContactStatusSelectedOption = function (campaignContactStatuses) {

			switch (campaignContactStatuses) {
				case '1':
					campaignContactStatuses = ['NEW'];
					break;
				case '2':
					campaignContactStatuses = ['INITIALCONTACT', 'INITIALRESPONSE', 'SECONDCONTACT', 'SECONDRESPONSE', 'APPLIED'];
					break;
				case '3':
					campaignContactStatuses = ['INITIALRESPONSE', 'SECONDCONTACT', 'APPLIED'];
					break;
				case '4':
					campaignContactStatuses = ['APPLIED'];
					break;
				default:
					campaignContactStatuses = [];
			}
			return campaignContactStatuses;
		};
		$scope.filterObject = {};
	}
]);


/**********************************
 * Filter Controller
 **********************************/
appCtrlModule.controller('CampaignContactFilterCtrl', ['$scope', 'openFilter', 'closeFilter', 'campaignService',
	function ($scope, openFilter, closeFilter, campaignService) {
		$scope.openFilter = function () {
			openFilter();
		};

		$scope.closeFilter = function () {
			closeFilter();
		};

		$scope.triggerSearch = function () {
			getCampaignContacts();
		};

		// Makes the copy of the object and sets the page number to zero;
		function getCampaignContacts(newValue, oldValue) {
			// if(typeof newValue != 'undefined' && typeof oldValue != 'undefined' && angular.equals(newValue, oldValue)){
			// return;
			// }

			var _args = angular.copy($scope.filterObject);

			//replace select option number with the appropriate 'campaignContactStatuses' string
			_args.campaignContactStatuses = $scope.replaceContactStatusSelectedOption(_args.campaignContactStatuses);
			// changing the filter always sets the page to zero;
			_args.page = 0;


			//Need to add page loading image
			campaignService.getCampaignContacts(_args, function (results) {});

		}

		function getCampaignPreferences(newValue, oldValue) {
			var _args = angular.copy($scope.filterObject);
			//Support bounce filtering in campaign contacts
			if (_args.campaignContactPreferences === 'BOUNCED') {
				_args.campaignContactPreferences = '';
				_args.contactPreferences = ['BOUNCE_OPT_IN', 'BOUNCE_LIMITED', 'BOUNCE_UNSUBSCRIBED'];
			}
			//replace select option number with the appropriate 'campaignContactStatuses' string
			_args.campaignContactStatuses = $scope.replaceContactStatusSelectedOption(_args.campaignContactStatuses);
			// changing the filter always sets the page to zero;
			_args.page = 0;
			//Need to add page loading image
			campaignService.getCampaignContacts(_args, function (results) {});
		}

		$scope.clearSearch = function () {
			window.location.reload(true);
		};

		$scope.clearKeywords = function () {
			$scope.filterObject.keywords = '';
			getCampaignContacts();
		};

		$scope.filterObject.campaignContactStatuses = '';

		$scope.$watch('filterObject.campaignContactStatuses', function (newValue, oldValue) {
			getCampaignContacts(newValue, oldValue);
		}, true);

		$scope.$watch('filterObject.campaignContactPreferences', function (newValue, oldValue) {
			getCampaignPreferences(newValue, oldValue);
		}, true);
	}
]);


/**********************************
 * Header Controller
 **********************************/
appCtrlModule.controller('CampaignContactHeaderCtrl', ['$scope', 'campaignService', 'modalService', '$q',
	function ($scope, campaignService, modalService, $q) {
		$scope.pageSize = 10;
		$scope.start = 0;
		$scope.end = 0;
		$scope.total = 0;
		$scope.page = 0;
		$scope.showError = false;

		$scope.maxResultsFilters = {
			'1': {
				'text': '50'
			},
			'2': {
				'text': '100'
			},
			'3': {
				'text': '250'
			},
			'4': {
				'text': '500'
			}
		};

		$scope.setMaxResults = function (maxResults) {
			$scope.currentMaxResults = $scope.maxResultsFilters[maxResults];
			if ($scope.currentMaxResults) {
				$scope.pageSize = parseInt($scope.maxResultsFilters[maxResults].text);
				$scope.filterObject.maxResults = $scope.pageSize;
			}
			if (!$scope.maxResultsDropDown) {
				$scope.maxResultsDropDown = !$scope.maxResultsDropDown;
			}
			//Need to add page loading image
			campaignService.getCampaignContacts(angular.extend(angular.copy($scope.filterObject), {
				campaignContactStatuses: $scope.replaceContactStatusSelectedOption($scope.filterObject.campaignContactStatuses),
				page: 0,
				maxResults: $scope.pageSize
			}));
		};

		//Perform Action
		$scope.performActionFilter = {
			'1': {
				'text': i18n['JV_CAMPAIGNCONTACTLIST_REMOVE_CONTACT'],
				'key': 'removeContact'
			},
			//'2': {'text':'Copy to Existing Campaign','key':'copyCampaign'},
			'3': {
				'text': i18n['JV_CAMPAIGNCONTACTLIST_SEND_TO_SELECTED_CONTACTS'],
				'key': 'SendToSelected'
			}
		};
		$scope.currentPerformActionFilter = $scope.performActionFilter[1];

		// Sort Actions
		$scope.sortFilters = {
			'1': {
				'text': i18n['JV_CAMPAIGNCONTACTLIST_NAME'],
				'key': 'name'
			},
			'2': {
				'text': i18n['JV_CAMPAIGNCONTACTLIST_LAST_SENT'],
				'key': 'lastSent'
			}
		};
		$scope.currentSorter = $scope.sortFilters['2'];

		$scope.$on('campaignContactsListResults', function (event, results) {
			$scope.pageSize = results.pageCount || $scope.pageSize;
			$scope.total = results.resultCount;
			$scope.page = results.page || 0;
			$scope.start = $scope.total !== 0 ? ($scope.page * $scope.pageSize) + 1 : 0;
			var _end = ($scope.page * $scope.pageSize) + $scope.pageSize;
			$scope.end = (_end > $scope.total) ? $scope.total : _end;
			$scope._resultObjects.selectedEIds = [];
			$scope.removePageLoading();
		});

		// pagination method.
		$scope.paginate = function (ifForward) {
			// Stop the backend calls for pagination for pages which do not exist.
			if (ifForward && ($scope.end === $scope.total)) {
				return;
			} else if ($scope.start === 1 && $scope.page === 0 && !ifForward) {
				return;
			}
			//Need to add page loading image
			campaignService.getCampaignContacts(angular.extend(angular.copy($scope.filterObject), {
				campaignContactStatuses: $scope.replaceContactStatusSelectedOption($scope.filterObject.campaignContactStatuses),
				page: $scope.page + (ifForward ? 1 : -1),
				maxResults: $scope.pageSize,
				sortBy: ($scope.currentSorter) ? $scope.currentSorter.key : null
			}));
		};

		$scope.sortDropDown = false;
		$scope.actionDropDown = false;

		// togglers
		$scope.toggleSorters = function () {
			$scope.sortDropDown = !$scope.sortDropDown;
		};

		$scope.toggleActions = function () {
			$scope.actionDropDown = !$scope.actionDropDown;
		};

		$scope.setSorter = function (sortNumber) {
			$scope.showError = false;
			$scope.currentSorter = $scope.sortFilters[sortNumber];
		};

		// showing the error in the header is there is some error.
		function validateAndShowError() {
			// this gets set in the root scope of the page where it can be extended and is available to all the controllers inside.
			if (!$scope._resultObjects.selectedEIds || $scope._resultObjects.selectedEIds.length < 1) {
				// show error
				$scope.errorText = i18n['JV_CAMPAIGNCONTACTLIST_PLEASE_SELECT_ONE_OR_MORE_CONTACT_'];
				$scope.showError = true;
				return {
					error: true
				};
			} else {
				return {
					'error': false,
					'ids': $scope._resultObjects.selectedEIds,
					'selectedObjects': $scope._resultObjects.selectedObjects,
					'total': $scope._resultObjects.total
				};
			}
		}

		$scope.performAction = function (actionNumber) {
			$scope.showError = false;
			var validationObj = validateAndShowError();
			// Stop the execution if there is some error.
			if (validationObj.error) {
				return;
			}
			$scope.currentPerformActionFilter = $scope.performActionFilter[actionNumber];
			// validate if there is any selection. Otherwise show error. 
			switch (parseInt(actionNumber)) {
				case 1:
					var deferred = $q.defer();

					modalService.confirmCampaignContactsRemove({
						ids: validationObj.ids
					}, deferred);
					deferred.promise.then(function (result) {
						//Need to add page loading image
						campaignService.removeFromCampaign({
							'ids': validationObj.ids
						}, function () {
							campaignService.getCampaignContacts({
								page: 0,
								maxResults: $scope.pageSize
							});
						});
					});
					break;
				case 2:

					break;
				case 3:
					campaignService.getEmailContents({
						stripContents: true
					}, function (result) {
						if (result && result.resultList && result.resultList.length) {
							if (validationObj && validationObj.selectedObjects && validationObj.selectedObjects.length > 9) {
								validationObj.showMoreContacts = true;
								validationObj.showMoreLength = validationObj.selectedObjects.length - 9;
							} else {
								validationObj.showMoreContacts = false;
							}
							//Need to add page loading image
							modalService.getScheduleCampaign(validationObj);
						} else {
							$scope.errorText = 'There are currently no email messages or unsent messages in this campaign. To add a message, click Email Content.';
							$scope.showError = true;
							return;
						}
					});

					break;
				default:
					// Do something.
			}
		};


		// Watch for changes in the header filters.
		$scope.$watch('currentSorter', function (newValue, oldValue) {
			if (angular.equals(newValue, oldValue)) {
				return;
			}
			var _args = {
				sortBy: newValue.key,
				// changing the filter always sets the page to zero;
				page: 0,
				maxResults: $scope.pageSize
			}
			//Need to add page loading image
			campaignService.getCampaignContacts(_args);
		});

		$scope.$watch('currentPerformActionFilter', function (newValue, oldValue) {
			if (angular.equals(newValue, oldValue)) {
				return;
			}
		});
	}
]);


/**********************************
 * Grid Controller
 **********************************/
appCtrlModule.controller('CampaignContactGridCtrl', ['$scope', '$rootScope',
	function ($scope, $rootScope) {
		$scope.originalCopyResults = [];
		$scope.checked = {};

		$scope.$watch('selectAll', function (val) {
			if (val !== undefined) {
				var currentlyChecked = angular.copy(_selectedContacts);
				if (val) {
					_selectedContacts = [];
					_selectedContactsEIds = [];
					$scope.results.forEach(function (entity) {
						$scope.addCheck(entity);
						$scope.checked[entity.EId] = true;
					});
				} else {
					currentlyChecked.forEach(function (entity) {
						$scope.addCheck(entity);
						$scope.checked[entity.EId] = false;
					});
				}
			}
		});

		$scope.$on('campaignContactsListResults', function (event, results) {
			$scope.results = results.resultList || [];
			// metrics hash
			var metricsHash = {};
			if (results.metricsArray) {
				for (var k = 0, l = results.metricsArray.length; k < l; k++) {
					metricsHash[results.metricsArray[k].EId] = results.metricsArray[k].lastDateSent;
				}
			}
			for (var metric in results.metrics) {
				results.metrics[metric].lastDateSent = metricsHash[metric];
			}
			$scope.originalCopyResults = angular.copy(results);
			if (typeof results.resultList !== 'undefined' && results.resultList.length) {
				for (var i = 0, j = results.resultList.length; i < j; i++) {
					results.resultList[i].hidePreference = true;
					if (results.resultList[i].primaryEmail && Object.keys(results.resultList[i].primaryEmail).length !== 0) {
						results.resultList[i].notEmptyEmail = true;
					} else {
						results.resultList[i].notEmptyEmail = false;
					}
					var contactNotifyPref = results.resultList[i].notifyPref
					if (contactNotifyPref === 'UNSUBSCRIBED') {
						results.resultList[i].roundColor = 'jv-roundRed';
						results.resultList[i].indicatorText = 'Opted Out';
					} else if (contactNotifyPref && contactNotifyPref.startsWith('BOUNCE')) {
						results.resultList[i].roundColor = 'jv-roundRed';
						results.resultList[i].indicatorText = 'Bounced';
					} else {
						results.resultList[i].roundColor = 'jv-roundGreen';
						results.resultList[i].indicatorText = 'Has Not Opted Out';
					}
				}
			}

			$scope.selectAll = false;
			$scope.checked = {};
			_selectedContacts = [];
			_selectedContactsEIds = [];
		});

		var _selectedContacts = [];
		var _selectedContactsEIds = [];
		// change in the input box.

		$scope.openNotifPref = function (entity, results) {
			if (typeof results !== 'undefined' && results.length) {
				for (var i = 0, j = results.length; i < j; i++) {
					results[i].hidePreference = true;
				}
			}
			entity.hidePreference = false;
		};

		$scope.closeNotifPref = function (entity) {
			entity.hidePreference = true;
		};

		$scope.addCheck = function (entity) {
			var _available = $.inArray(entity.EId, _selectedContactsEIds);

			if (_available === -1) {
				//add
				_selectedContacts.push(entity);
				_selectedContactsEIds.push(entity.EId);
			} else {
				//remove
				_selectedContacts = $.grep(_selectedContacts, function (element, index) {
					return (element.EId !== entity.EId);
				});
				_selectedContactsEIds = $.grep(_selectedContactsEIds, function (entityId, index) {
					return (entityId !== entity.EId);
				});
			}

			//create an object and broadcast the information of the selected contacts.
			var broadcastObject = {
				'total': $scope.originalCopyResults.resultCount,
				'selectedCount': _selectedContacts.length,
				'selectedObjects': _selectedContacts,
				'selectedEIds': _selectedContactsEIds
			};

			$rootScope.$broadcast('campaignSelectionCount', broadcastObject);
		};

		//used to send the display name
		$scope.getDisplayName = function (entity) {
			var displayName = '';
			//collate the first, middle & lastNames and display the same
			//collation should happend when we read the values from database
			if (entity.firstName) {
				displayName += entity.firstName;
			}
			if (entity.middleName) {
				displayName += ' ' + entity.middleName;
			}
			if (entity.lastName) {
				displayName += ' ' + entity.lastName;
			}
			//if the displayName is still empty, check if the entity contains fullName
			//and assign the same to the former. This will happen when we read values from ES
			if (!displayName && entity.name) {
				displayName = entity.name;
			}
			displayName = displayName.trim();
			//if displayName is empty, then give the name not found msg.
			return displayName ? displayName : i18n['CAMPAIGN2_CAMPAIGNCONTACTLIST_NAME_NOT_FOUND'];
		};
	}
]);